import {mainQuery} from '@github-ui/react-core/future/main-query'
import {reposPulseAppBuilder} from '../config/app-builder'

export type PulseResponse = {
  committerDataPath: string
  diffstatSummaryPath: string
  overviewDataPath: string
}

export const pulseRoute = reposPulseAppBuilder.createQueryRouteConfig('pulseRoute', {
  path: '/:owner/:repo/pulse',
  queries: [mainQuery<PulseResponse>()],
})
